import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { DEPT_MENUS } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/departments/menus/new")({
  component: () => <DeptContentForm cfg={DEPT_MENUS} />,
});
